import { createAction } from 'redux-actions';

export const SET_TRANSPORT_ON_MAP = 'SET_TRANSPORT_ON_MAP';
export const SET_TRANSPORT_ON_MAP_FILTER = 'SET_TRANSPORT_ON_MAP_FILTER';
export const SET_TRANSPORT_ON_MAP_BOUNDS = 'SET_TRANSPORT_ON_MAP_BOUNDS';

export const setTransportOnMap = createAction<string[]>(SET_TRANSPORT_ON_MAP);
export const setTransportOnMapFilter = createAction<boolean>(SET_TRANSPORT_ON_MAP_FILTER);
export const setTransportOnMapBounds = createAction<any>(SET_TRANSPORT_ON_MAP_BOUNDS);
